import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { appActions } from '../store';
import { SERIES_IDS } from '../constants';

/**
 * Custom hook to fetch products and set active profile based on style and size
 * Matches style to product.name and size to product.color
 */
export function useActiveProfile() {
    const dispatch = useDispatch();
    const style = useSelector(state => state.shared.style);
    const size = useSelector(state => state.shared.size);
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    // Fetch products from series 9700
    useEffect(() => {
        const URL = `https://lizard.chameleonpower.com/CDN/ProductsBySeries/${SERIES_IDS.STYLES}.json`;
        
        fetch(URL)
            .then((response) => response.json())
            .then((data) => {
                setProducts(Array.isArray(data) ? data : []);
                setLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching products for active profile:', error);
                setLoading(false);
            });
    }, []);

    // Find and set active profile when style or size changes
    useEffect(() => {
        if (loading || products.length === 0) return;
        if (!style || !size) {
            dispatch(appActions.clearActiveProfile());
            return;
        }

        // Find product that matches both style (name) and size (color)
        const matchingProduct = products.find(product => {
            const nameMatch = product.name && 
                product.name.toLowerCase() === style.toLowerCase();
            const colorMatch = product.color && 
                product.color.toLowerCase() === size.toLowerCase();
            
            return nameMatch && colorMatch;
        });

        if (matchingProduct) {
            dispatch(appActions.setActiveProfile(matchingProduct));
            console.log('Active profile set:', matchingProduct);
        } else {
            dispatch(appActions.clearActiveProfile());
            console.log('No matching product found for:', { style, size });
        }
    }, [style, size, products, loading, dispatch]);

    return { loading };
}
